import { useState } from "react";
import { useLookupTypeFraisQuery } from "../../stores/OkOkStore";
import type { TypeFrais } from "../../types/TypeFrais";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";
import './TypeFrais.scss'
function TypeFraisList(){
    const [params,setParams]=useState<Record<string, string>>({page:"0"});
    const { data, error, isLoading } = useLookupTypeFraisQuery(params);
    const {translate}=useTrads();
    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <div className="type-frais list">
                <table className="table">
                <thead>
                    <tr>
                        <th>{translate('type_frais_nom')}</th>
                        <th>{translate('type_frais_supplement')}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((type_frais:TypeFrais) => (

                        <tr key={type_frais.id}>
                            <td>{type_frais.name}</td>
                            <td>{type_frais.supplement}</td>
                            <td><div className="table-picto">{type_frais.picto?<img src={type_frais.picto.filename} className="img-fluid"  width={type_frais.picto.size?.w} height={type_frais.picto.size?.h} title="" alt=""/>:null}</div></td>
                            <td>
                                <NavLink to={type_frais.id.toString()}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                            <td>
                                <NavLink to={`/type_frais/${type_frais.id.toString()}/edit`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-pencil-fill"></i>
                                </NavLink>
                            </td>    
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </div>
            ):null
        );
}
export default TypeFraisList;